import React, { useEffect, useRef } from 'react'

import styles from './Notification.module.scss'
import { REMOVE, useNotificationContext } from './NotificationContext'
import { NotificationItem as NotificationItemType } from './types'

type Props = {
  notification: NotificationItemType
  autoDeleteTime?: number
}

export const NotificationItem = ({
  notification,
  autoDeleteTime,
}: Props): JSX.Element => {
  const { notificationsDispatch } = useNotificationContext()
  const ref = useRef<HTMLDivElement>(null)
  const pause = useRef<boolean>(false)

  useEffect(() => {
    const handlerEnter = () => {
      pause.current = true
    }
    const handlerLeave = () => {
      pause.current = false
    }
    const setTimer = () =>
      setInterval(() => {
        if (pause.current) {
          return
        }
        if (autoDeleteTime) {
          notificationsDispatch({ type: REMOVE, payload: notification })
        }
      }, autoDeleteTime)

    const interval = setTimer()

    const element = ref.current

    element?.addEventListener('mouseenter', handlerEnter)

    element?.addEventListener('mouseleave', handlerLeave)

    return () => {
      clearInterval(interval)
      element?.removeEventListener('mouseenter', handlerEnter)
      element?.removeEventListener('mouseleave', handlerLeave)
    }
  }, [autoDeleteTime, notification, notificationsDispatch])

  return (
    <div className={styles['notification']} ref={ref}>
      <div className={styles['notification-info']}>
        <i
          className={`${styles['notification-info_icon']} ${
            styles[notification.type]
          }`}
        ></i>
        <div className={styles['notification-info_message']}>
          {notification.description}
        </div>
      </div>
      <div className={styles['notification-progress']}>
        <svg
          width="46"
          height="46"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.svg}
        >
          <circle
            cx="25"
            cy="25"
            r="23"
            className={styles.svg_circle}
            stroke="#26CD58"
            strokeWidth="4"
            fillOpacity="0"
          />
        </svg>
        <i
          className="icon-close"
          onMouseDown={e => {
            e.preventDefault()
            e.stopPropagation()
            notificationsDispatch({
              type: REMOVE,
              payload: notification,
            })
          }}
        ></i>
      </div>
    </div>
  )
}
